import { render, staticRenderFns } from "./DbProductFormDialog.vue?vue&type=template&id=990da2a8"
import script from "./DbProductFormDialog.vue?vue&type=script&lang=ts"
export * from "./DbProductFormDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports